<div class="tw-pl-4 tw-italic" data-cy="signature-request-status">
    <span *ngIf="sending(); else status">
      Sending Signature Request
    </span>
  <ng-template #status>
    <div *ngIf="isPrimary; else secondary">
      {{ primarySignatureStatus }}
      <span *ngIf="primarySignedDate" class="signed-date">({{ primarySignedDate | date }})</span>
    </div>
    <ng-template #secondary>
      {{ signatureStatus }}
      <span *ngIf="signedDate" class="signed-date">({{ signedDate | date }})</span>
    </ng-template>
  </ng-template>
</div>
<div class="tw-w-full contact-action">
  <button
    [disabled]="signatureRequestSending.sending"
    (click)="sendSignatureRequest()"
    matTooltip="Sends a Marketplace signature request to this owner."
    matTooltipPosition="above"
    data-cy="send-signature-request-button"
    class="send-button tw-w-full tw-flex tw-flex-row tw-h-32"
    mat-button
    color="primary">
    <mat-spinner
      *ngIf="sending(); else text"
      diameter="20">
    </mat-spinner>
    <ng-template #text>
      <span class="tw-flex-grow tw-text-left tw-text-black" *ngIf="signatureStatus === 'Signature Request Sent'; else first">Send Another Marketplace Signature Request</span>
      <ng-template #first><span class="tw-flex-grow tw-text-left tw-text-black">Send Marketplace Signature Request</span></ng-template>
      <span class="send-icon-container tw-inline-block tw-flex-none tw-rounded-lg tw-border tw-px-2 tw-size[32]">
        <mat-icon class="send-icon tw-place-items-center tw-mt-1">send</mat-icon>
      </span>
    </ng-template>
  </button>
</div>
